<template>
    <div>
      <vs-prompt
      @cancel="canceld"
      @accept="accepted"
      @close="closed"
      :active.sync="dlgActive"
      :title="popupTitle"
      :accept-text="$t('COM.SAVE')"
      :cancel-text="$t('COM.CANCEL')"
      id="promptEditOfferOptions"
      :is-valid="formValid">
       <div>
        <div>
              <div class="default-input d-flex align-items-center mb-3 mt-2">
                  <vs-input :label="$t('OFFERS.ADD_OFFER.LABEL.BEZ')"  class="float-left mr-2 inputx" :placeholder="$t('OFFERS.ADD_OFFER.LABEL.PLACEHOLDER.BEZ')"  v-model="offer.bez"/>
              </div>
              <TextAreaAccordeon :label="$t('OFFERS.ADD_OFFER.DESCRIPTION')" :type="OFFERDESCRIPTION"  v-model="offer.description"></TextAreaAccordeon>
              <span v-if="counterDanger" class="color_danger">{{$t('OFFERS.ADD_OFFER.LABEL.DESCR_EMPTY')}}</span>
              <div class="default-input d-flex align-items-center mb-3 mt-2">
                <vs-checkbox v-model="offer.printDescriptionBold">{{$t('OFFERS.ADD_OFFER.LABEL.PRINT_BOLD')}}</vs-checkbox>
              </div>
              <div class="default-input d-flex align-items-center mb-3 mt-2">
                  <DatePicker v-if="!offer.useDeliveryText" ref="pickerDeliveryDate"  Type="date" class="float-left" :Label="$t('INVOICE.ADD_INVOICE.DELIVERY_DATE')" :OkCancelLabel="{ok:$t('COM.OK'),cancel:$t('COM.CANCEL')}" :PopUpTitel="$t('INVOICE.ADD_INVOICE.TITLE.DELIVERY_DATE')" v-model="offer.deliverydate"></DatePicker>
                  <vs-input v-if="offer.useDeliveryText" :disabled="!offer.useDeliveryText" :label="$t('INVOICE.ADD_INVOICE.LABEL.DELIVERY_TEXT')"  class="float-left mr-2 inputx" :placeholder="$t('INVOICE.ADD_INVOICE.LABEL.PLACEHOLDER.DELIVERY_TEXT')"  v-model="offer.deliveryText"/>
                  <vs-checkbox  v-model="offer.useDeliveryText">{{$t('INVOICE.ADD_INVOICE.LABEL.USE_DELIVERY_TEXT')}}</vs-checkbox>
              </div>
              <div class="default-input clearfix align-items-center mb-1">
                <div class="float-left" >
                  <vs-select  :label="$t('OFFERS.ADD_OFFER.LABEL.DELIVERYCOND')" v-model="offer.deliverycondition_fk">
                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in deliveryconditions" />
                  </vs-select>
                  <div class="clearfix">
                    <vs-input-number  v-model="offer.deliverycondition_pricecustom" class="inputx float-left" :label="$t('OFFERS.ADD_OFFER.CUSTOM_PRICE')"/>  
                  </div>
                </div>
                <div class="float-left ml-3" >
                  <vs-select   :label="$t('OFFERS.ADD_OFFER.LABEL.PAYMENTCOND')" v-model="offer.paymentcondition_fk">
                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in paymentconditions" />
                  </vs-select>  
                </div>
                <div class="float-left ml-3" >
                  <vs-select   :label="$t('OFFERS.ADD_OFFER.LABEL.SPECIALDISCOUNT')" v-model="offer.special_discount_fk">
                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in specialdiscounts" />
                  </vs-select>      
                </div>
              </div>
              <div class="default-input d-flex align-items-center mb-3 mt-2">
                <vs-checkbox v-model="offer.isEu" >{{offer.isEuText}}</vs-checkbox>
              </div>
        </div>
       </div>
     </vs-prompt>
    </div>
</template>
<script>

import helperMethods from '../../../helper/staticFuncHelper';
import codeHelper from '../../../helper/staticCodeHelper';
import enumHelper from '../../../helper/enumHelper';
import DatePicker from '../DatePicker.vue';
import TextAreaAccordeon from '../TextAreaAccordeon.vue';
import {inputSelectType} from '../../../helper/enumHelper';

export default {
  name: "EditOfferOptions",
  props:[],
  components:{
    DatePicker,
    TextAreaAccordeon
  },
  data: function (){
     return {
      dlgActive:false,
      popupTitle:this.$t('OFFERS.ADD_OFFER.TITLE'),
      offer:null,
      OFFERDESCRIPTION: inputSelectType.OFFERDESCRIPTION
    }
  }, 
  mounted () {
    this.$store.dispatch('numbergroup/getNumbergroupsByCompany',0,{ root: true });
    this.ClearForm();
    
  },
  methods:{
      ...helperMethods,
      ...codeHelper,
      ...enumHelper,
      ShowDlg(){
        this.ClearForm();   
        this.dlgActive=true;
      },
      closed(){
        this.ClearForm();
        this.$emit('Canceld');
      },
      InitDlgData(data){
        this.ClearForm();
        if(this.IsNotNull(data))
        {
          this.offer = data;

          this.popupTitle = this.$t('OFFERS.ADD_OFFER.TITLE.EDIT') + ' ('+this.offer.offer_nr+')';

          this.dlgActive=true;
        }
      },    
      accepted(){

          this.$emit('Accepted');
          this.ClearForm();
      },
      canceld(){
        this.ClearForm();
        this.$emit('Canceld');
      },
      ClearForm(){ 
      }
  },
  computed:{
    formValid(){
      let valid = false;
      if(this.IsNotNull(this.offer) && this.IsEmpty(this.offer) == false)
      {
        valid = this.IsTextEmpty(this.offer.description) == false;
      }
      return valid;
    },
    deliveryconditions(){    
      return this.GetListOfDeliveryConditionsForSelect(this.offer.country_fk,this.offer.currency_fk);
    },
    paymentconditions(){    
      return this.GetListOfPaymentConditionsForSelect(this.offer.country_fk,this.offer.currency_fk);
    },
    specialdiscounts()
    {
      return this.GetListOfSpecialDiscountsForSelect();
    },
    counterDanger()
    {
      let danger = true;
      if(this.IsNotNull(this.offer) && this.IsEmpty(this.offer) == false)
      {
        danger = this.IsTextEmpty(this.offer.description);
      }
      return danger;
    }
  },
  watch:{

  }
};
</script>
<style>
div#promptEditOfferOptions > div.vs-dialog{
  max-width: 800px !important;
}
div#promptEditOfferOptions > div.vs-dialog > 
div.vs-dialog-text > div > div > 
div.vs-tabs > div.con-slot-tabs > div.vs-tabs--content{
min-height: 450px;
}

</style>